/* 무비 유료 풀이 결제 — 질문 하나를 통째로 산다(9/29 사장님 「우리도 질문당 가격으로 갈꺼야」 · 「회원 할인 없앰」).
   값은 질문마다 한 값(서버 deploy/prices.js). 회원 · 비회원 같은 값이고 장 고르기는 없다.
   구매 화면의 단추 「구매하기 · 값」 하나 — 새로 시작한 진행은 지난 구매와 상관없이 늘 산다(10/22).
   웹은 페이앱(PAY_MODE live) · 시험 구매(mock) · 꺼 둠(off — 결제 없이 바로), 토스판은 토스 인앱결제(window.BGTOSS — toss/tosspay.src.js).
   10/1 코드 점검 — 페이앱 결제는 서버가 만들고(deploy/pay.js 주문내기) 결제창 주소만 준다. 이 화면은 누른 순간 열어 둔 창을 그 주소로 보낸다(payapp-lite.js 를 안 싣는다).
   산 풀이는 그번 보기(이 탭의 난수 x-bg-session)와 풀이 요청에 묶인다 — 바로 사지 않으면 처음부터(9/28). */
(() => {
  const T = window.BGTOSS || null;   // 토스판 — 토스 인앱결제(toss/tosspay.src.js). 웹에는 없다
  // 10/1 아이폰 앱(apple/ — 웹뷰 꼬리표 BamgwabiApp/) — 앱 안 유료 풀이는 Apple 인앱결제만(앱스토어 3.1.1). 앱 다리(BGApp)로 StoreKit 결제를 띄운다
  // 10/20 — 앱은 Capacitor 다리를 맨 위 화면에만 넣는다(forMainFrameOnly). 같은 출처 안쪽 화면(영상 뒤 결제 iframe)은 위 화면의 다리를 쓴다 —
  //   예전에는 안쪽 화면이 웹 결제로 가 팝업이 막히고 서버도 앱의 웹 주문을 거절해 영상 뒤 결제(타로 · MBTI)를 살 수 없었다(토스판 10/19 와 같은 꼴)
  const 앱다리 = (() => {
    if (typeof window.Capacitor?.nativePromise === "function") return window.Capacitor;
    try { const p = window.parent; if (p && p !== window && p.location.origin === location.origin && typeof p.Capacitor?.nativePromise === "function") return p.Capacitor; } catch { /* 다른 출처 */ }
    return null;
  })();
  const A = !T && /BamgwabiApp\//.test(globalThis.navigator?.userAgent || "") && 앱다리
    ? (이름, 값) => 앱다리.nativePromise("BGApp", 이름, window.BGLANG?.withLocale(값 || {}) ?? (값 || {})) : null;
  // 10/2 플레이 스토어에서 받은 안드로이드 앱(TWA) — 유료 풀이는 구글 플레이 결제만(playpay.js window.BGPLAY · deploy/pay.js 플레이결제).
  // 크롬은 플레이 앱 안에서만 구글 결제를 준다 — 알아내기는 비동기라 값을 받기(load) 전에 기다린다. 보통 크롬 · 사파리에서는 거짓이라 웹 그대로.
  let P = false;
  const P준비 = !T && !A && window.BGPLAY ? window.BGPLAY.ready().then((ok) => (P = !!ok)).catch(() => false) : Promise.resolve(false);
  // 그번 보기(세션) — 이 탭에만 두는 난수. 산 풀이는 이 값과 풀이 요청에 묶는다.
  // 10/1 코드 점검 — 토스판은 토스 결제창(tosspay.js)과 같은 값을 쓴다(저장이 막혀 난수를 새로 만들 때 둘이 달라지면 결제는 되고 풀이는 안 열렸다)
  const SID = (() => {
    const ok = (v) => /^[A-Za-z0-9_-]{16,64}$/.test(v || "");
    try { const v = T?.sid?.(); if (ok(v)) return v; } catch { /* 아래에서 만든다 */ }
    // 10/20 — 같은 출처 안쪽 화면(영상 뒤 결제 iframe)은 위 화면과 한 보기다. 저장이 막힌 브라우저에서는 둘이 따로 난수를 만들어, 결제(안쪽)와 입력 연결(위)이 서로 다른 사람이 됐다
    try { const p = window.parent; if (p && p !== window && p.location.origin === location.origin) { const v = p.BGPAY?.head?.()["x-bg-session"]; if (ok(v)) return v; } } catch { /* 다른 출처 */ }
    const make = () => [...crypto.getRandomValues(new Uint8Array(16))].map((b) => b.toString(16).padStart(2, "0")).join("");
    try { let v = sessionStorage.getItem("bg.pay.sid"); if (!ok(v)) { v = make(); sessionStorage.setItem("bg.pay.sid", v); } return v; }
    catch {
      // 저장이 막힌 브라우저 — 같은 탭에서 사이트 안을 옮겨 다녀도(구매 화면 → 풀이 화면 · 새로고침) 같은 보기로 남게 탭 이름(window.name, sessionStorage 처럼 탭에만 남는다)에 둔다
      const m = /^bgsid:([a-f0-9]{32})$/.exec(String(window.name || ""));
      if (m) return m[1];
      const v = make();
      if (!window.name) try { window.name = `bgsid:${v}`; } catch { /* 이 화면 동안만 */ }
      return v;
    }
  })();
  const won = (n) => `${Number(n || 0).toLocaleString("ko-KR")}원`;
  const $id = (id) => document.getElementById(id);
  const head = () => ({ ...(T ? T.head() : {}), ...(P ? { "x-bg-shell": "play" } : {}), "x-bg-session": SID });   // 10/2 — 플레이 앱이면 서버가 구글 상품 번호를 주고 페이앱 주문을 막는다
  // 10/2 점검 — 통신이 끊기면 브라우저 오류 글(「Failed to fetch」 · 「Load failed」)이 그대로 보였다. play.js(askEngine)와 같은 말로 바꾼다
  // 10/8 애플 기준(3-화면글-점검 1~9) — 결제 오류는 「무슨 일 · 어떻게 하면 되는지」를 함께
  const NET = "인터넷 연결이 끊겼어요. 연결을 확인하고 다시 눌러 주세요";
  const AGAIN = "결제를 마치지 못했어요. 잠시 뒤에 다시 눌러 주세요";
  async function 타로준비(q) {
    if (q?.purchase === 'before-input-v1' && menu?.mode === 'mock') return;
    if (q?.questionId !== "tarot" && !(q?.purchase === 'before-input-v1' && !q.questionId.startsWith('test.scene.') && q.questionId !== 'test.mbti110')) return;
    const r = await fetch("/api/writer/status", { cache: "no-store", signal: AbortSignal.timeout?.(5000) }).catch(() => null);   // 10/8 점검 — iOS 15(사파리 16 미만)에는 AbortSignal.timeout 이 없어 던졌다
    const s = r?.ok ? await r.json().catch(() => null) : null;
    if ((s?.ready ?? s?.mac) !== true) throw new Error("지금은 풀이를 작성할 수 없어요. 잠시 뒤에 다시 구매해 주세요");
  }
  const post = async (url, body) => {
    if (/^\/api\/pay\/(?:apple\/|play\/)?start$/.test(url)) await 타로준비(body?.req);
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", ...head() }, body: JSON.stringify(body || {}) })
      .then(async (r) => { const j = await r.json().catch(() => ({})); if (!r.ok) throw Object.assign(new Error(j.error || AGAIN), j, { status: r.status, 서버: !!j.error }); return j; }, () => { throw new Error(NET); });
  };
  // 알림에 싣는 글 — 한글이 없는 글(토스 결제창 등이 넘긴 브라우저 · 통신 오류)은 그대로 보이지 않는다
  // 10/20 — 글이 어디서 왔는지로 가른다. 예전에는 한글이 있나로 갈라, 서버가 손님 언어로 옮겨 준 결제 오류(영어 · 일본어 · 중국어)까지 「결제를 마치지 못했어요」로 덮었다.
  //   서버가 준 문장(서버: true)과 이 화면이 쓴 문장(한글 — 화면 사전이 옮긴다)은 그대로, 브라우저 · 결제창이 넘긴 날것 오류만 바꾼다
  const 말 = (e) => { const m = String(e?.message ?? e ?? ""); return e?.서버 || /[가-힣]/.test(m) ? m : /fetch|load failed|network|connection/i.test(m) ? NET : AGAIN; };
  const 보이기 = (t) => { try { toast(t); } catch { /* play.js 없음 */ } };
  const say = (e) => 보이기(말(e));
  let menu = null, ready = null, busy = false, lateTok = 0, payWin = null;
  // 웹 페이앱 주문 상태 — 낸 사람에게만 보인다(deploy/pay.js 주문상태). 못 받으면 ""
  const state = (no) => fetch(`/api/pay/order?no=${encodeURIComponent(no)}`, { cache: "no-store", headers: head() }).then((r) => r.json()).then((s) => String(s?.상태 || "")).catch(() => "");
  // 10/1 코드 점검 — 이 탭에서 낸 주문을 질문마다 남긴다(같은 풀이 요청일 때만 쓴다). 웹: 창을 닫아 그친 주문을 다음에 누를 때 새 주문 전에 먼저 되묻는다.
  // 10/28 사장님 — 토스에서 결제는 됐는데 그 자리에서 못 받은 주문은 이 화면에서 잇지 않고 보관함 「다시 받기」로 받는다(toss/tosspay.src.js receive)
  const WAIT = "bg.pay.wait";
  const reqNow = () => { try { const r = engineReq(); return { q: String(r.questionId || ""), s: JSON.stringify(r) }; } catch { return null; } };
  const waits = () => { try { const o = JSON.parse(sessionStorage.getItem(WAIT) || "{}"); return o && typeof o === "object" ? o : {}; } catch { return {}; } };
  const waitOf = () => { const n = reqNow(), w = n && waits()[n.q]; return w && w.req === n.s ? w : null; };
  const setWait = (w) => {
    const n = reqNow(); if (!n) return;
    try { const all = waits(); if (w) all[n.q] = { ...w, req: n.s }; else delete all[n.q]; sessionStorage.setItem(WAIT, JSON.stringify(all)); } catch { /* 못 남겨도 이번 결제는 그대로 */ }
  };

  const style = document.createElement("style");
  style.textContent = ".pay[disabled]{opacity:.45;cursor:default}.pay .cn{font-weight:400;opacity:.75}"
    // 10/8 결제 수단 시트(우리 화면 틀 hig.css 의 .hsheet · .hb) — 아래에서 올라오는 한 장, 위에 풀이 이름 · 값, 가운데 카카오페이 · 토스페이, 아래에 넓은 카드 결제
    + ".paysheet-back{position:fixed;inset:0;z-index:1000;display:flex;align-items:flex-end;justify-content:center;background:rgba(0,0,0,.55);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px)}"
    + ".paysheet{width:100%;max-width:520px;box-sizing:border-box;padding:0 var(--s4,16px) calc(var(--s4,16px) + env(safe-area-inset-bottom));animation:paysheetUp .22s cubic-bezier(.2,.8,.2,1)}"
    + "@keyframes paysheetUp{from{transform:translateY(24px);opacity:0}to{transform:none;opacity:1}}@media (prefers-reduced-motion:reduce){.paysheet{animation:none}}"
    + ".paysheet-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}.paysheet-title{font-size:var(--t-headline,1rem);font-weight:700;line-height:1.4;word-break:keep-all;padding-top:6px}"
    + ".paysheet-x{flex:none;width:44px;height:44px;margin:-6px -12px 0 0;border:0;background:transparent;color:var(--label-2,rgba(235,235,245,.6));font-size:var(--t-headline,1rem);cursor:pointer}"
    + ".paysheet-price{margin:2px 0 var(--s5,20px);font-size:var(--t-title1,1.647rem);line-height:1.214;font-weight:700;color:var(--tint,#FFB800)}"
    + ".paysheet-brands{display:flex;flex-wrap:wrap;gap:var(--s2,8px);margin-bottom:var(--s2,8px)}.paysheet-brand{flex:1 1 120px;min-width:0;min-height:52px;border:0;color:#fff;font-weight:700}"
    + ".paysheet-kakaopay{background:#fee500;color:#191919}.paysheet-tosspay{background:#fff}.paysheet-brand img{display:block;height:22px;width:auto}.paysheet-card{min-height:52px}"
    + ".paysheet-toss-mark{display:inline-flex;height:22px;gap:3px}.paysheet-toss-mark::before,.paysheet-toss-mark::after{content:\"\";height:22px;background:url(\"/app/pay/tosspay-logo.png\") no-repeat;background-size:114px 22px}.paysheet-toss-mark::before{width:24.25px;background-position:left center}.paysheet-toss-mark::after{width:37.75px;background-position:right center}";
  document.head.appendChild(style);

  // 사야 하나 — 꺼 둠(off)이거나 이번 진행에서 이미 샀으면 바로 연다
  const need = () => !!(menu && !menu.탈 && menu.mode !== "off" && !menu.샀나);
  // 10/28 — 토스에서 결제는 됐는데 풀이를 받지 못한 이 질문(그 자리 실패 tosspay 보관함 · 새로고침이나 다시 들어와도 보관함 칸에 남은 주문)은
  //   단추가 다시 「구매」가 되지 않고 보관함으로 보낸다(그 결제는 보관함 「다시 받기」로 받는다. 다시 사면 두 번 낸다)
  let 보관함질문 = null;
  const 보관함으로 = () => !!(T && 보관함질문 && need() && reqNow()?.q === 보관함질문);
  const 보관함열기 = () => { try { window.top.location.href = "/#vault"; } catch { location.href = "/#vault"; } };
  // 토스 주문 기록에 남기는 화면 — 보관함 칸 이름(영상 뒤 결제는 위 영상 화면의 제목)과 입력 전에 산 구매가 입력을 받을 풀이 화면(purchase.js engineTarget)
  const 결제화면 = () => {
    let doc = document; try { if (window.BGAFTERCHECKOUT && window.parent !== window) doc = window.parent.document; } catch { /* 다른 출처 */ }
    const 이름 = String(doc.title || "").split(" | ")[0], 주소 = window.engineTarget?.();
    return { ...(이름 ? { 이름 } : {}), ...(주소 ? { 주소 } : {}) };
  };
  function label() {
    const btn = $id("payBtn"); if (!btn) return;
    if (need() && A && 앱확인맞나()) { btn.innerHTML = "<span>결제 확인</span>"; btn.disabled = false; return; }   // 10/1 코드 점검 — 낸 Apple 거래를 다시 확인하는 단추
    if (보관함으로()) { btn.innerHTML = "<span>보관함에서 받기</span>"; btn.disabled = false; return; }
    const 값 = need() && menu.파는 && menu.값;
    // 앱에서는 StoreKit · 구글 플레이가 알려 준 값을 보인다(menu.애플값)
    // 10/2 점검 — 「결과보기」는 이미 샀거나 결제가 꺼진 때만. 값을 못 받은 때(통신 · 서버 오류)는 「구매하기」 — 누르면 까닭을 알리고 다시 받는다(buy)
    const 열림 = !!menu && !menu.탈 && (menu.mode === "off" || !!menu.샀나);
    let 시작 = false; try { 시작 = engineReq()?.purchase === 'before-input-v1'; } catch {}
    btn.innerHTML = 값 ? `<span>구매하기</span> <span class="cn">${menu.애플값 && menu.애플값 === menu.값기다림 ? `<i class="lw-mini lw-in" role="img" aria-label="${menu.애플값}"></i>` : menu.애플값 || menu.달러 || won(menu.값)}</span>` : `<span>${열림 ? (시작 ? "시작하기" : "결과 보기") : "구매하기"}</span>`;   // 결제 후 미진행 구매는 시작, 결과 판은 결과 보기. 페이팔 나라는 청구 달러(menu.달러)
    btn.disabled = need() && !값;   // 팔 값이 없는 풀이(열 수 있는 장이 없음)
  }
  // ① 구매 화면을 그린 뒤 부른다 — 이 질문의 값 · 이번 진행에서 샀나를 받아 단추에 값을 붙인다
  function paint() { ready = load(); return ready; }
  // 10/8 점검 — 값 묻기가 겹치면 늦게 온 옛 답이 새 답을 덮었다(토스는 「샀나」만 믿고 결제창을 연다). 마지막으로 물은 것의 답만 쓴다
  let loadSeq = 0;
  async function load() {
    const my = ++loadSeq;
    menu = null;
    await P준비;
    let m;
    // 10/22 이번 — 이번 진행의 구매번호(결제 뒤 입력에 이은 것), 또는 이 화면에서 이 요청 그대로 막 낸 주문의 번호({ 주문 } — 서버가 확인한다). 서버는 이것으로만 샀나를 준다 —
    //   같은 입력의 지난 주문으로는 열지 않는다(늘 새로 시작 · 지난 결과는 보관함)
    try { const q = engineReq(); if (window.BGENTRY) await window.BGENTRY.bind(q); m = await post("/api/pay/menu", { req: q, 이번: window.BGENTRY?.purchase ?? (직접산 && 직접산.s === reqNow()?.s ? { 주문: 직접산.no } : null) }); } catch (e) { m = { 탈: 말(e) }; }
    if (my !== loadSeq) return menu;
    menu = m;
    if (menu.샀나) setWait(null);   // 이미 산 풀이 — 남겨 둔 주문은 더 볼 일이 없다
    if (menu.시트) { try { if (menu.카카오페이) new Image().src = KAKAO_LOGO; if (menu.토스페이) new Image().src = TOSS_LOGO; } catch { /* 시트를 열 때 받는다 */ } }   // 시트가 열릴 때 로고가 바로 보이게 미리 받아 둔다
    // 10/23 사장님 「어느 곳이든 완성이 안 된 곳은 로딩창이 떠야 정상」 — 값을 받는 동안 단추의 값 자리에 밤과비 로딩(logo-wait.js .lw-mini.lw-in — 구매 단추가 있는 play · tarot · purchase.html 이 싣는다), 화면 읽기는 「가격 확인 중…」
    if ((A && menu.애플상품) || (P && menu.구글상품)) menu.애플값 = menu.값기다림 = window.BGLANG?.locale === 'en' ? 'Loading price…' : '가격 확인 중…';
    label();
    if (T && need()) T.unreceived?.().then((rows) => { const q = reqNow()?.q; if (q && rows.some((r) => !r.모름 && !r.못열음 && r.questionId === q)) { 보관함질문 = q; label(); } }).catch(() => {});
    if (need() && menu.파는) globalThis.BGEV?.("buy_view");   // 10/22 손님 흐름 단계(public/app/funnel.js) — 구매 화면(값이 붙은 구매하기)이 보였다
    if (P && menu.구글상품) { const m0 = menu; window.BGPLAY.price(menu.구글상품).then((v) => { if (menu === m0) { menu.애플값 = v || (window.BGLANG?.locale === 'en' ? 'Price unavailable' : '가격을 확인할 수 없어요'); label(); } }).catch(() => { if(menu===m0){menu.애플값=window.BGLANG?.locale==='en'?'Price unavailable':'가격을 확인할 수 없어요';label();} }); }   // 실제 Google Play 가격만 표시한다
    if (A && menu.애플상품) {   // 앱 — Apple 이 실제로 받을 값(원화 표시)을 받아 단추를 다시 그린다
      // 10/1 밤 — 원화가 아니면(해외 계정 · 심사 계정) StoreKit 값 그대로 보인다(「$14.99원」이 되지 않게)
      const m0=menu;
      A("products", { ids: [menu.애플상품] }).then((r) => { const p = r?.products?.[0]; if (menu===m0) { menu.애플값 = window.BGLANG?.price(p) || p?.displayPrice || (window.BGLANG?.locale==='en'?'Price unavailable':'가격을 확인할 수 없어요'); label(); } }).catch(() => {if(menu===m0){menu.애플값=window.BGLANG?.locale==='en'?'Price unavailable':'가격을 확인할 수 없어요';label();}});
    }
    return menu;
  }

  // ② 단추를 눌렀을 때(play.js payBtn → BGPAY.buy)
  function buy(consentWin = null) {
    if (busy) return;
    if (보관함으로()) { 보관함열기(); return; }
    if (need() && menu.파는) globalThis.BGEV?.("buy_click");   // 10/22 손님 흐름 단계(public/app/funnel.js)
    if (/^\/app\/purchase(?:\.html)?\/?$/.test(globalThis.location?.pathname || "") && !window.BGAGREEMENT?.purchase) { say("동의 안내를 불러오지 못했어요. 새로고침 후 다시 눌러 주세요"); return; }
    if (window.BGAGREEMENT && !window.BGAGREEMENT.purchase(win => buy(win), () => need() && !T && !A && !P && menu.mode === "live" && (menu.페이팔 || !menu.시트) ? openWin() : null, close)) return;
    if (need() && menu.파는) globalThis.BGEV?.("agree");   // 10/22 손님 흐름 단계(public/app/funnel.js) — 동의를 마쳤다(이미 했으면 바로)
    lateTok += 1;   // 닫은 결제창을 뒤에서 묻던 것(lateCheck)은 그친다 — 새로 누르면 webBuy 가 남은 주문을 먼저 되묻는다
    try { SFX.wake(); } catch { /* 소리 없이 */ }   // 누른 이 순간에 효과음 소리판을 깨운다 — 결제를 기다린 뒤에는 아이폰이 「누른 순간」으로 치지 않는다
    // 값이 오기 전에 누름 — 값만 받아 단추에 붙인다. 살 것이 있으면 한 번 더 눌러야 산다(10/1 코드 점검 — 기다린 뒤에는 결제창을 열 수 없다). 살 것이 없으면(꺼 둠 · 이미 삼) 바로 연다
    if (!menu) { busy = true; (ready || load()).finally(() => { busy = false; if (menu?.탈) 보이기(menu.탈); else if (menu && !need()) 열기(); }); return; }
    if (menu.탈) { 보이기(menu.탈); paint(); return; }
    if (!need()) { 열기(); return; }
    if (A && 앱확인맞나()) { appRecheck(); return; }        // 10/1 밤 — 결제는 됐는데 서버 확인이 안 된 Apple 거래도 새로 사지 않고 다시 확인한다
    if (!menu.파는 || !menu.값) return;
    if (T) { tossBuy(); return; }
    if (A) { appBuy(); return; }
    if (P) { playBuy(); return; }
    if (menu.mode !== "live") { webBuy(null); return; }
    if (menu.페이팔) {   // 페이팔을 쓰는 나라 — 한국 결제 시트 없이 페이팔 승인 창만
      const win = consentWin || openWin();
      if (!win || win.closed) { say("브라우저가 결제 창을 막았어요. 팝업 차단을 풀고 다시 눌러 주세요"); return; }
      webBuy(win, "paypal");
      return;
    }
    if (menu.시트) { openSheet(); return; }   // 10/8 서버가 시트를 켠 때만(PAY_SHEET=1): 결제 수단을 먼저 고른다(토스페이 · 네이버페이 · 카드 결제) — 결제창(작은 창)은 수단 단추를 누를 때 열린다
    const win = consentWin || openWin();   // 동의 저장을 기다리는 경우에는 확인 버튼을 누른 순간 준비한 창을 쓴다.
    if (!win || win.closed) { say("브라우저가 결제 창을 막았어요. 팝업 차단을 풀고 다시 눌러 주세요"); return; }   // 10/1 코드 점검 — 창 없이 주문을 내지 않는다
    webBuy(win);
  }
  /* 10/8 결제 수단 시트 — 구매하기를 누르면 바로 결제창이 열리지 않고 아래에서 시트가 올라온다: 토스페이(서버가 켠 때만) · 카카오페이 · 카드 결제(페이앱).
     카카오페이는 서버의 가맹점 설정이 켜진 때만 보인다. 작은 결제창은 수단 단추를 누른 그 순간에 열어야 팝업이 막히지 않는다 — 그래서 창은 여기서 연다. */
  const KAKAO_LOGO = "/app/pay/kakaopay-logo.png";
  const TOSS_LOGO = "/app/pay/tosspay-logo.png";   // 토스 공식 기본 로고(logo-toss-pay)를 같은 비율로 줄인 것(456×88)
  let sheet = null, payHeld = false;
  function syncPay() {   // 10/9 시트 · 작은 결제창이 열려 있는 동안 대사 영상과 더빙을 멈춘다(play · tarot · dub.js). 네이티브 결제창은 페이지가 가려져 따로 멈춘다
    const on = !!sheet || !!(payWin && !payWin.closed);
    if (on === payHeld) return;
    payHeld = on;
    try { dispatchEvent(new CustomEvent("bamgwabi:payhold", { detail: on })); } catch { /* 무대 없음 */ }
  }
  function closeSheet() {
    if (!sheet) return false;
    const s = sheet; sheet = null;
    document.removeEventListener("keydown", s.key, true); s.back.remove();
    try { s.from?.focus?.(); } catch { /* 돌아갈 곳 없음 */ }
    syncPay();
    return true;
  }
  function openSheet() {
    if (sheet) return;
    const back = document.createElement("div");
    back.className = "paysheet-back";
    back.innerHTML = '<div class="hsheet paysheet" role="dialog" aria-modal="true" aria-labelledby="paySheetT"><div class="hsheet-grabber"></div>'
      + '<div class="paysheet-head"><div class="paysheet-title" id="paySheetT"></div><button type="button" class="paysheet-x" aria-label="닫기">✕</button></div>'
      + '<div class="paysheet-price"></div><div class="paysheet-brands"></div>'
      + '<button type="button" class="hb hb-filled hb-block paysheet-card" data-m="card"><span>카드 결제</span></button></div>';
    back.querySelector(".paysheet-title").textContent = menu?.제목 || "";
    if (!menu?.제목) back.querySelector(".paysheet-title").hidden = true;
    back.querySelector(".paysheet-price").textContent = won(menu?.값);
    const brands = back.querySelector(".paysheet-brands");
    for (const [m, 이름] of [...(menu?.카카오페이 ? [["kakaopay", "카카오페이"]] : []), ...(menu?.토스페이 ? [["tosspay", "토스페이"]] : [])]) {
      const b = document.createElement("button");
      b.type = "button"; b.className = `hb paysheet-brand paysheet-${m}`; b.dataset.m = m;
      // 원본 로고의 심볼과 pay를 같은 비율로 표시한다. 버튼 이름은 전체 결제수단명으로 읽는다.
      if (m === "tosspay") b.innerHTML = `<span class="paysheet-toss-mark" role="img" aria-label="${window.BGLANG?.t?.(이름) || 이름}"></span>`;
      else if (m === "kakaopay") b.innerHTML = `<img src="${KAKAO_LOGO}" alt="${window.BGLANG?.t?.(이름) || 이름}" height="22" draggable="false">`;
      else b.innerHTML = `<span>${이름}</span>`;
      brands.appendChild(b);
    }
    back.addEventListener("click", (e) => {
      const b = e.target.closest?.("button[data-m]");
      if (b) {
        if (busy) return;
        const win = openWin();   // 누른 순간에 열어 둔다(팝업 막힘)
        if (!win || win.closed) { say("브라우저가 결제 창을 막았어요. 팝업 차단을 풀고 다시 눌러 주세요"); return; }
        const m = b.dataset.m; closeSheet(); webBuy(win, m === "card" ? undefined : m);
        return;
      }
      if (e.target === back || e.target.closest?.(".paysheet-x")) closeSheet();
    });
    const key = (e) => { if (e.key === "Escape") { e.stopPropagation(); closeSheet(); } };
    document.addEventListener("keydown", key, true);
    document.body.appendChild(back);
    sheet = { back, key, from: document.activeElement };
    try { back.querySelector(".paysheet-card").focus(); } catch { /* 초점 못 옮김 */ }
    syncPay();
  }
  function wait() { const btn = $id("payBtn"); if (btn) { btn.disabled = true; btn.innerHTML = "<span>결제 확인 중…</span>"; } }
  // 10/8 점검 — startPaid 약속을 catch 없이 불렀다(던지면 잡히지 않은 오류로 남았다). 실패하면 단추만 다시 그린다
  // 10/29 리뷰 — 결과 열기가 실패하면 안내 없이 단추만 「구매하기」로 돌아가 방금 낸 손님이 결제가 안 된 줄 알았다. 까닭을 알린다(다시 누르면 다시 확인만 한다)
  const 열기 = () => Promise.resolve().then(() => startPaid()).catch((e) => { label(); say(e); });
  // 10/22 구매번호 없이 입력 요청 그대로 이 화면에서 산 풀이(영상 뒤 결제를 쓰지 않는 흐름) — 그 요청 · 막 낸 그 주문번호만 서버가 맞춰 본다(메뉴 이번 { 주문 })
  let 직접산 = null;
  function done(ok, no) {
    if (ok) { if (menu) menu.샀나 = true; setWait(null); if (!window.BGENTRY) 직접산 = no ? { s: reqNow()?.s ?? null, no } : null; }
    label();
    if (ok) 열기();
  }
  async function webBuy(win, 방식) {
    globalThis.BGEV?.("method", { d: 방식 || (win ? "card" : "test") });   // 10/22 손님 흐름 단계(public/app/funnel.js) — 고른 결제 수단
    busy = true; wait();
    try {
      // 10/1 코드 점검 — 이 풀이로 이 탭에서 전에 낸 주문이 창을 닫은 뒤에 끝났을 수 있다. 새 주문을 내기 전에 먼저 되묻고, 「됨」이면 새로 사지 않고 연다
      const w = waitOf();
      if (w?.no && (await state(w.no)) === "됨") { close(win); done(true, w.no); return; }
      // 10/16 코드 리뷰 — 아이패드 사파리는 맥으로 소개해 서버가 컴퓨터용 카카오페이 창(QR)을 줬다. 터치 기기인지는 화면이 알려 준다(카카오페이일 때만)
      const 터치기기 = () => { const n = globalThis.navigator, ua = n?.userAgent || ""; return /Android|iPhone|iPad|iPod|Mobile/i.test(ua) || (n?.maxTouchPoints > 1 && /Macintosh/.test(ua)); };
      const o = await post("/api/pay/start", { req: engineReq(), 애플페이: canApplePay(), ...(방식 ? { 방식 } : {}), ...(방식 === "kakaopay" ? { 모바일: 터치기기() } : {}) });
      if (o.mode === "live" && o.주문번호) {
        // 10/1 코드 점검 — 서버는 실제 결제인데 이 화면은 결제창을 안 열었다(시험 구매로 알았다). 기다린 뒤에는 창을 열 수 없어 한 번 더 누르게 한다
        //   (서버가 15분 안에 낸 같은 주문의 결제창을 다시 준다 — 새 결제를 만들지 않는다)
        if (!win) { if (menu) menu.mode = "live"; label(); say("결제 창을 열려면 구매하기를 한 번 더 눌러 주세요"); return; }
        setWait({ no: o.주문번호 });
        await payapp(o, win);
      } else close(win);
      done(true, o.주문번호);
    } catch (e) { if (!e?.창둠) close(win); done(false); say(e); }
    finally { busy = false; }
  }
  /* Apple 인앱결제(앱) — 서버가 주문(값 · token)을 정하고 → StoreKit 결제(appAccountToken = token) → 서버가 Apple 에 거래를 물어 「됨」 → 거래를 끝낸다(finish).
     서버가 확인하기 전에는 거래를 끝내지 않는다 — 앱이 꺼져도 다음에 켤 때 남은 거래를 다시 보낸다(아래 appRecover). */
  // 10/1 밤 코드 리뷰 — 결제는 됐는데 서버 확인이 실패한 거래. 전엔 단추가 「구매하기」로 돌아가 다시 누르면 새 주문 · 새 결제가 열렸다(두 번 결제)
  let 앱확인 = null;
  // 10/8 점검 — reset() 뒤 다음 풀이에도 앞 풀이의 「결제 확인」이 붙었다. 그 거래를 낸 풀이 요청(JSON)을 함께 적고, 지금 풀이와 같을 때만 쓴다
  let 앱확인요청 = null;
  const 앱확인맞나 = () => !!앱확인 && 앱확인요청 === reqNow()?.s;
  const APP_WAIT = "bambee.apple.pending", APP_RESUME = "bambee.apple.resume";
  const appRead = (key) => { try { const o = JSON.parse(localStorage.getItem(key) || "{}"); return o && typeof o === "object" && !Array.isArray(o) ? o : {}; } catch { return {}; } };
  const appWrite = (key, o) => { try { localStorage.setItem(key, JSON.stringify(o)); } catch { throw new Error("결제 정보를 저장하지 못했어요. 저장 공간을 확인해 주세요"); } };
  const appContext = (req) => {
    try { const s = JSON.parse(sessionStorage.getItem("bambee.tarot.resume") || "null"); return req.questionId === "tarot" && JSON.stringify(s?.req) === JSON.stringify(req) ? s.free : null; } catch { return null; }
  };
  const appRecord = (r) => Object.values(appRead(APP_WAIT)).find((o) => o.token === r?.token || o.receipt?.transactionId === r?.transactionId)
    || Object.values(appRead(APP_RESUME)).find((o) => o.token === r?.token || o.receipt?.transactionId === r?.transactionId);
  function appForget(r) {
    for (const key of [APP_WAIT, APP_RESUME]) {
      const all = appRead(key);
      for (const [k, o] of Object.entries(all)) if ((r?.token && o.token === r.token) || (r?.transactionId && o.receipt?.transactionId === r.transactionId)) delete all[k];
      appWrite(key, all);
    }
  }
  const 앱확인중 = new Map();
  async function appRecheck() {
    busy = true; wait();
    try { const g = await appGrant(앱확인); 앱확인 = null; if (g.ok) await paint(); done(!!menu?.샀나); }
    catch (e) { if (e?.끝) { try { await A("finish", { transactionId: 앱확인.transactionId }); } catch { /* 다음에 */ } 앱확인 = null; } done(false); say(e); }
    finally { busy = false; }
  }
  // 끝나지 않은 거래(앱이 꺼졌거나 승인을 기다리던 결제)를 먼저 보낸다 — 이 풀이가 열리면 true
  async function appPending() {
    let 열림 = false;
    const p = await A("pending").catch(() => null);
    for (const it of p?.items || []) {
      try { const g = await appGrant(it); if (g.ok) 열림 = true; }
      catch (e) { if (e?.끝) { try { await A("finish", { transactionId: it.transactionId }); } catch { /* 다음에 */ } } }
    }
    return 열림;
  }
  async function appBuy() {
    globalThis.BGEV?.("method", { d: "apple" });   // 10/22 손님 흐름 단계(public/app/funnel.js)
    if (!menu.애플상품) { say("결제 상품 정보를 받지 못해 지금은 결제할 수 없어요. 잠시 뒤에 다시 눌러 주세요"); return; }
    busy = true; wait();
    let r = null;
    try {
      if (await appPending()) { await paint(); if (menu?.샀나 && !menu.탈) { done(true); return; } if (!menu || menu.탈) { done(false); 보이기(menu?.탈 || "결제를 확인하지 못했어요. 잠시 뒤에 다시 눌러 주세요"); return; } }   // 남은 거래로 이미 열렸으면 새로 사지 않는다(메뉴를 못 받았으면 산 것으로 치지 않는다)
      const req = engineReq(), prior = Object.values(appRead(APP_WAIT)).find((o) => JSON.stringify(o.req) === JSON.stringify(req));
      if (prior?.receipt) { 앱확인 = prior.receipt; 앱확인요청 = JSON.stringify(req); await appRecheck(); return; }
      // 10/8 점검 — 승인 기다림(Ask to Buy)이 거절되면 그 뒤로 내내 못 샀다. 기다림에 때를 적고 30분이 지나면 새로 살 수 있게 한다(옛 기록의 true 는 지난 것으로 본다)
      if (prior?.waiting && Date.now() - Number(prior.waiting) < 30 * 60 * 1000) { done(false); say("결제 승인을 기다리고 있어요"); return; }
      const o = await post("/api/pay/apple/start", { req });
      if (o.이미) { done(true); return; }
      const all = appRead(APP_WAIT);
      all[o.token] = { token: o.token, 상품: o.상품, 주문번호: o.주문번호, req, free: appContext(req), 때: Date.now() };
      appWrite(APP_WAIT, all);   // 결제창을 열기 전에 원래 풀이 입력을 남긴다.
      r = await A("buy", { id: o.상품, token: o.token });
      if (r?.cancelled) globalThis.BGEV?.("pay_close", { d: "apple" });   // 10/22 손님 흐름 단계(public/app/funnel.js)
      if (r?.cancelled) { appForget({ token: o.token }); done(false); return; }
      if (r?.pending) { const all = appRead(APP_WAIT); if (all[o.token]) all[o.token].waiting = Date.now(); appWrite(APP_WAIT, all); done(false); say("결제 승인을 기다리고 있어요"); return; }
      await appGrant(r);
      done(true, o.주문번호);
    } catch (e) {
      if (r?.transactionId && !e?.끝) { 앱확인 = r; 앱확인요청 = reqNow()?.s ?? null; }   // 결제는 됐다 — 다음 누름은 새로 사지 않고 이 거래를 다시 확인한다(label 「결제 확인」)
      else if (r?.transactionId && e?.끝) A("finish", { transactionId: r.transactionId }).catch(() => {});   // 받을 수 없는 거래(상품 다름 · 취소)는 비운다
      done(false); say(e);
    }
    finally { busy = false; }
  }
  function appGrant(r) {
    if (앱확인중.has(r.transactionId)) return 앱확인중.get(r.transactionId);
    const p = (async () => {
      const old = appRecord(r), record = old ? { ...old, receipt: r } : null;
      if (record) { const all = appRead(APP_WAIT); all[record.token] = record; appWrite(APP_WAIT, all); }
      let g;
      try { g = await post("/api/pay/apple/grant", { transactionId: r.transactionId, jws: r.jws }); }
      catch (e) { if (e?.끝) appForget(r); throw e; }
      if (g.ok) {
        if (record?.req?.questionId) {
          const all = appRead(APP_RESUME), q = record.req.questionId;
          if (!all[q] || Number(all[q].때 || 0) <= Number(record.때 || 0)) all[q] = record;
          appWrite(APP_RESUME, all);   // 이어 보기 입력을 보존한 뒤에만 Apple 거래를 끝낸다.
          const pending = appRead(APP_WAIT); delete pending[record.token]; appWrite(APP_WAIT, pending);
        }
        try { await A("finish", { transactionId: r.transactionId }); } catch { /* 다음에 다시 끝낸다 */ }
      }
      return g;
    })();
    앱확인중.set(r.transactionId, p);
    p.finally(() => 앱확인중.delete(r.transactionId)).catch(() => {});
    return p;
  }
  // 앱을 켤 때 끝나지 않은 거래(결제는 됐는데 서버 확인 전에 꺼짐)를 다시 확인한다. 우리 쪽에서 받을 수 없는 거래(취소 · 주문 없음)는 끝내서 비운다
  // 10/1 밤 코드 리뷰 — 서버가 「끝: true」(다시 보내도 소용없음)라고 할 때만 끝낸다(전엔 400 · 404 · 409 면 끝내 잠깐의 DB 오류에도 낸 돈이 사라졌다)
  function appRecover() { return appPending().then((열림) => { if (열림 && menu) paint(); }).catch(() => {}); }
  let A복구 = Promise.resolve();
  async function tossBuy() {
    globalThis.BGEV?.("method", { d: "toss" });   // 10/22 손님 흐름 단계(public/app/funnel.js)
    if (!menu.sku) { say("결제 상품 정보를 받지 못해 지금은 결제할 수 없어요. 잠시 뒤에 다시 눌러 주세요"); return; }
    busy = true; wait();
    // 입력 — 영상 뒤 결제(after-video-checkout.js BGAFTERCHECKOUT)는 입력 전에 산 구매를 이을 풀이 입력을 주문 기록에 함께 남긴다(그 자리에서 못 이으면 보관함 다시 받기가 쓴다)
    try { const req = engineReq(); await 타로준비(req); await T.buy({ sku: menu.sku, req, 견적: menu.견적, 입력: window.BGAFTERCHECKOUT?.req, 화면: 결제화면() }); done(true); }   // 토스 인앱결제 → 서버가 토스에 물어 확인하고 적는다
    catch (e) { if (e?.보관함) 보관함질문 = reqNow()?.q || null; done(false); say(e); }   // 결제는 됐는데 못 받았으면 tosspay 가 보관함 다시 받기를 말하고 단추는 보관함으로
    finally { busy = false; }
  }

  /* 페이앱 시작 — 토스판 번들에서는 이 사이를 잘라 낸다(tools/build_toss.mjs, 토스 안은 토스 인앱결제만) */
  /* ── 페이앱(웹 실제 결제 — PAY_MODE live) ── 누른 순간에 작은 창을 이 이름으로 열어 두고, 서버의 주문이 「됨」 이 될 때까지 묻는다. */
  function openWin() {
    const w = 440, h = 720;
    const left = Math.max(0, (screen.availWidth ?? 1200) / 2 - w / 2 + (screen.availLeft ?? 0));
    const top = Math.max(0, (screen.availHeight ?? 900) / 2 - h / 2 + (screen.availTop ?? 0));
    try {
      // 10/1 사장님 「작게 결제창이 나오면 되지 왜 전체화면으로 크게 나오는거야」 — 늘 같은 이름(PayAppWindow)으로 열면 예전에 그 이름으로 열린 큰 탭이
      //   남아 있을 때 그 탭을 다시 써 작은 창이 되지 않았다. 누를 때마다 새 이름의 작은 창을 열고, 앞서 연 결제창은 닫는다.
      try { payWin?.close(); } catch { /* 이미 닫힘 */ }
      const win = window.open("", `bgpay${Date.now().toString(36)}`, `popup=yes,width=${w},height=${h},left=${Math.round(left)},top=${Math.round(top)},resizable=yes,scrollbars=yes,status=no,toolbar=no,menubar=no,location=no`);
      if (win) { try { win.resizeTo(w, h); win.moveTo(Math.round(left), Math.round(top)); } catch { /* 크기 못 바꿈 */ } }
      payWin = win;
      syncPay();
      return win;
    } catch { syncPay(); return null; }
  }
  const close = (win) => { try { win?.close(); } catch { /* 이미 닫힘 */ } if (win && win === payWin) syncPay(); };
  // Apple Pay 를 쓸 수 있는 브라우저인가(사파리 · 아이폰) — 아니면 서버가 결제창에서 Apple Pay 를 뺀다(deploy/pay.js 결제수단)
  const canApplePay = () => { try { return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments()); } catch { return false; } };
  // 닫은 결제창에서 결제를 마쳤는데 알림이 늦게 오는 때 — 단추는 이미 되돌렸고, 2분 동안 뒤에서 조용히 더 묻다가 「됨」이면 바로 연다
  function lateCheck(no) {
    const tok = (lateTok += 1), until = Date.now() + 2 * 60 * 1000;
    (async () => {
      while (tok === lateTok && Date.now() < until) {
        await new Promise((r) => setTimeout(r, 5000));
        if (tok !== lateTok || busy) return;
        if ((await state(no)) === "됨") { if (tok === lateTok && !busy) done(true, no); return; }
      }
    })();
  }
  // 10/1 코드 점검 — 결제는 서버가 페이앱에 만들고(판매자 · 통보 주소 · 금액 · 서명은 서버만 안다) 결제창 주소(o.결제창)만 준다. 누른 순간 열어 둔 창을 그 주소로 보낸다.
  async function payapp(o, win) {
    const url = String(o?.결제창 || "");
    if (!(/^https?:\/\/([a-z0-9-]+\.)*payapp\.kr\//i.test(url) || (o?.방식 === "kakaopay" && /^https:\/\/(online-payment\.kakaopay\.com|online-pay\.kakao\.com|mockup-pg-web\.kakao\.com)\//.test(url)) || (o?.방식 === "tosspay" && /^https:\/\/pay\.toss\.im\//.test(url)) || (o?.방식 === "paypal" && /^https:\/\/(www\.paypal\.com|www\.sandbox\.paypal\.com|paypal\.com|sandbox\.paypal\.com)\//.test(url)))) throw new Error("결제창을 열지 못했어요");
    if (!win || win.closed) throw new Error("결제창이 닫혔어요. 다시 눌러 주세요");   // 다시 누르면 서버가 같은 주문의 결제창을 다시 준다(15분 안)
    try { win.location.replace(url); } catch { throw new Error("결제창을 열지 못했어요"); }
    // 10/1 사장님 「결제창을 껏더니 화면은 결제 진행중이야」 — 창을 닫으면 5초만 더 묻고 단추를 되돌린다(전엔 2분 동안 「결제 확인 중」에 묶였다).
    //   닫은 창에서 결제를 마쳤는데 알림이 늦는 때는 뒤에서 2분 더 묻다가 「됨」이면 바로 연다(lateCheck). 다시 누르면 새 주문 전에 먼저 되묻는다(webBuy).
    const end = Date.now() + 10 * 60 * 1000;
    let shut = 0;
    for (let n = 0; Date.now() < end; n += 1) {
      await new Promise((r) => setTimeout(r, shut || n < 10 ? 1500 : 4000));
      const s = await state(o.주문번호);
      if (s === "됨") { close(win); return; }
      if (s === "어긋남") throw new Error("결제 금액이 주문과 달라 결제를 마치지 못했어요. 돈이 빠져나갔다면 고객센터로 알려 주세요");
      if (s === "요청취소" || s === "승인취소") { close(win); throw new Error("결제가 취소됐어요"); }   // 10/26 점검 — 취소면 남은 결제창도 닫는다
      if (!shut && win.closed) { shut = Date.now(); syncPay(); }
      if (shut && Date.now() - shut >= 5000) globalThis.BGEV?.("pay_close", { d: o?.방식 || "card" });   // 10/22 손님 흐름 단계(public/app/funnel.js) — 결제 없이 결제창을 닫았다
      if (shut && Date.now() - shut >= 5000) { lateCheck(o.주문번호); throw new Error("결제가 끝나지 않았어요. 구매하기를 다시 누르면 이어서 결제할 수 있어요"); }
    }
    // 10/8 점검 — 10분이 지나면 아직 결제 중인 창까지 닫고 늦은 결제를 묻지 않았다. 뒤에서 더 묻고(lateCheck) 창은 그대로 둔다(webBuy 가 창둠이면 닫지 않는다)
    lateCheck(o.주문번호);
    throw Object.assign(new Error("결제 확인이 늦어지고 있어요. 잠시 뒤에 다시 확인해 주세요"), { 창둠: true });
  }
  /* 페이앱 끝 */

  /* 10/2 구글 플레이 결제(플레이 앱) — 서버 주문 → 구글 결제창 → 서버가 구글에 물어 확인 · 소비(playpay.js). 결제창을 닫으면 단추만 되돌린다. */
  async function playBuy() {
    globalThis.BGEV?.("method", { d: "play" });   // 10/22 손님 흐름 단계(public/app/funnel.js)
    if (!menu.구글상품) { say("결제 상품 정보를 받지 못해 지금은 결제할 수 없어요. 잠시 뒤에 다시 눌러 주세요"); return; }
    busy = true; wait();
    try {
      const g = await window.BGPLAY.buy(post, engineReq());
      busy = false;
      if (g?.닫음) globalThis.BGEV?.("pay_close", { d: "play" });   // 10/22 손님 흐름 단계(public/app/funnel.js)
      if (g?.닫음) { label(); return; }
      done(true);
    } catch (e) { busy = false; done(false); say(e); }
  }
  // 앱을 켤 때 — 결제는 됐는데 확인하지 못한 구매를 다시 보낸다(3일 안에 확인하지 않으면 구글이 돌려준다)
  const P복구 = P준비.then(async (ok) => { if (ok) { const 열림 = await window.BGPLAY.recover(post); if (열림 && menu) paint(); } }).catch(() => {});

  // 화면이 부르는 자리: 머리(그번 보기 · 토스판 표시) · 단추. 결과지 끝에 더 사는 칸은 없다(질문 하나를 통째로 산다).
  // 10/2 점검 — busy · closeWin: 무비의 뒤로 가기(play.js 막이)가 결제 중이면 이 화면을 떠나지 않고 결제창(페이앱 작은 창)만 닫는다(닫힌 창은 payapp 이 알아채 단추를 되돌린다)
  window.BGPAY = { head, buy, paint, menu: () => menu, reset: () => { closeSheet(); menu = null; ready = null; lateTok += 1; loadSeq += 1; }, resume: async (q) => {
    await Promise.all([P복구, A복구]);
    if (P) { await window.BGPLAY.recover(post, q); return window.BGPLAY.resume(q); }
    if (A) {
      // 10/8 점검 — 영수증 없는 옛 주문 기록(결제창만 열고 끝나지 않은 것)을 산 기록보다 먼저 집었다. 영수증이나 승인 기다림이 있는 것만
      const o = Object.values(appRead(APP_WAIT)).filter((x) => x.req?.questionId === q && (x.receipt || x.waiting)).sort((a, b) => Number(b.때 || 0) - Number(a.때 || 0))[0] || appRead(APP_RESUME)[q];
      if (o?.receipt) { try { await appGrant(o.receipt); } catch (e) { if (e?.끝) return null; 앱확인 = o.receipt; 앱확인요청 = JSON.stringify(o.req); } }
      return o || null;
    }
    return null;
  }, busy: () => busy || !!sheet, closeWin: () => { closeSheet(); close(payWin); } };   // 10/8 점검 — 아무도 안 부르던 빈 moreHtml · bindMore 는 지움

  if (A) {
    A복구 = appRecover();
    // 승인을 기다리던 결제(Ask to Buy 등)가 앱이 켜져 있는 동안 끝나면 Apple 이 알려 준다(밤과비다리.swift Transaction.updates → "transaction")
    try { window.Capacitor?.Plugins?.BGApp?.addListener?.("transaction", (it) => { appGrant(it).then((g) => { if (g?.ok) paint(); }).catch((e) => { if (e?.끝) A("finish", { transactionId: it.transactionId }).catch(() => {}); }); }); } catch { /* 다음에 켤 때 appRecover 가 보낸다 */ }
  }
})();
